// Builder for root CSS custom properties from plain variable entries.
// Only non-class and non-object variables are emitted here.
import { ensureSemicolon } from '../utils'
import { failClosedSecurityCheck } from '../../security/guard'
import { hasUnsafeCssPayload } from '@lentystyle/guard/shared'

// Create a `:root { ... }` rule from regular variable key/value pairs.
export function buildRootVariableRule(variables: Record<string, string>): string {
  const entries = Object.entries(variables).filter(([, value]) => isSafeRootVariableValue(value))
  // Skip root block generation when no regular variables exist.
  if (entries.length === 0) {
    return ''
  }

  return [':root {', ...entries.map(([name, value]) => `  ${name}: ${ensureSemicolon(value)}`), '}'].join('\n')
}

// Validate regular root-variable values before css emission.
function isSafeRootVariableValue(value: string): boolean {
  try {
    // Reuse shared payload predicate before structural brace validation.
    if (hasUnsafeCssPayload(value)) {
      return false
    } else if (value.includes('{') || value.includes('}')) {
      // Block structural braces in regular variable values.
      return false
    } else {
      // Return true for safe regular variable values.
      return true
    }
  } catch (error) {
    // Stop compile flow when root-variable sanitizer cannot execute.
    return failClosedSecurityCheck('isSafeRootVariableValue', error)
  }
}
